export default "__VITE_ASSET__CwODO8Mf__"